import React, { useState, useEffect, useRef } from 'react';
import { Modal, Upload, Button, message, Radio, RadioChangeEvent } from 'antd';
import apis from '@/pages/activity-manage/merchants/detail/components/merchant-pool/apis';
import './index.less';
import AddUploadList from './add-upload-list';
import api from '@/components/batch-operate/apis';
import env from '@/env';
import type { UploadProps } from 'antd';
import constants from './constant';
import './index.less';

const WhiteUpload: React.FC = () => {
  const [fileList, setFileList] = useState([]);
  const [fileType, setFileType] = useState(1);
  const [data, setData] = useState<{ [key: string]: string }>({});
  const [visible, setVisible] = useState(false);

  const handelCloseUploadRef = useRef(null);

  useEffect(() => {
    window.ACORE = window.ACORE || {};
    (window.ACORE as any).openWhiteUpload = ({ sceneCode, planCode, type, handelCloseUpload }: any) => {
      setData({ sceneCode, type, planCode });
      setVisible(true);
      handelCloseUploadRef.current = handelCloseUpload;
    };
  }, []);

  useEffect(() => {
    setFileType(1);
  }, [visible]);

  const upload = (e: any) => {
    const file = e.file;
    return new Promise(function (resolve) {
      const filereader = new FileReader();
      filereader.readAsDataURL(file);
      resolve('');
    })
      .then(() => {
        const formData = new FormData();
        formData.append('file', file);
        apis.fileUpload &&
          apis
            .fileUpload(formData)
            .then((res) => {
              const { ret } = res;
              if (ret && ret === '0' && res.data) {
                message.success('上传成功');
                e.onSuccess(res.data.urlList[0]);
              } else {
                message.error(res.msg);
                e.onError();
              }
            })
            .catch((err) => {
              message.error(err);
            });
      })
      .catch((error) => {
        e.onError(error);
      });
  };

  const submit = () => {
    let file = fileList.map((item: { response: string }) => item.response);
    api
      .taskStartBatch({
        // @ts-ignore
        bizCode: env.LONG_MISSION.RULES_UPLOAD,
        body: JSON.stringify({
          fileType: fileType,
          ...data,
        }),
        file: file.join(),
      })
      .then((res) => {
        if (res && res.ret === '0' && res.data.taskIds) {
          message.success('开始上传！');
          setFileList([]);
          //@ts-ignore
          handelCloseUploadRef.current && handelCloseUploadRef.current();
        } else {
          message.error(res.msg);
        }
      })
      .catch((err) => {
        message.error(err);
      });
  };

  const handleChange = ({ file, fileList: newList }: { file: any; fileList: any }) => {
    setFileList(newList);
  };

  const onRadioChange = (e: RadioChangeEvent) => {
    setFileType(e.target.value);
    setFileList([]);
  };

  const UProps: UploadProps = {
    customRequest: upload,
    maxCount: 10,
    multiple: true,
    onChange: handleChange,
    fileList: fileList,
  };

  const currConfig = constants[data.sceneCode]?.[data.type];

  if (!currConfig) return null;

  const downLoadUrl = () => {
    const item = currConfig?.options.filter((ele) => ele.value === fileType)[0];
    return item?.downLoadUrl;
  };

  return (
    <Modal
      title={currConfig?.modalTitle}
      visible={visible}
      width={1200}
      destroyOnClose
      onCancel={() => {
        setVisible(false);
      }}
      footer={null}
    >
      <div className="merchant-upload-wrap global-merchant-upload-wrap">
        <div className="merchant-upload-left-content">
          <div>
            <div style={{ marginBottom: '10px' }}>
              <div style={{ marginBottom: '10px' }} className="merchant-upload fontWeight">
                1 选择录入方式
              </div>
              <Radio.Group
                defaultValue={currConfig.options[0].value}
                onChange={onRadioChange}
                options={currConfig.options}
              />
            </div>
            <div className="merchant-upload fontWeight">2 使用模版录入</div>
            <div style={{ marginTop: '20px', marginRight: '16px' }} className="merchant-upload-icon">
              <Upload {...UProps}>
                <Button type="primary" ghost disabled={fileList.length >= 10}>
                  添加{currConfig.name}文件
                </Button>
              </Upload>
              <a
                className="merchant-upload-download"
                onClick={() => {
                  window.location.href = downLoadUrl();
                }}
              >
                下载模版
              </a>
            </div>
            <div className="merchant-upload-desc">
              *支持单次添加1个文件，单次上传10个文件
              <br />
              *单表格数量上限为5w
            </div>
          </div>
          <Button
            type="primary"
            block
            className="merchant-upload-left-btn"
            onClick={submit}
            disabled={fileList.length <= 0}
          >
            上传
          </Button>
        </div>
        <AddUploadList
          title={`已录入${currConfig.name}文件`}
          planCode={data.planCode}
          type={data.type}
          fileList={fileList}
          sceneCode={data.sceneCode}
        />
      </div>
    </Modal>
  );
};
export default WhiteUpload;
